const routesPersonal = [{
  path: "/personal",
  name: "personalManage",
  redirect: "/personal/center",
  component: () => import("@/views/personal/index.vue"),
  meta: {
    title: "route.personal",
    crumbs: "route.personal",
    isLogin: true
  },
  children: [{
    path: "/personal/center",
    component: () => import("@/views/personal/personal.vue"),
    name: "personalCenter",
    meta: {
      title: "route.profile",
      crumbs: "route.profile-crumb",
      isLogin: true,
      isNav: true
    }
  }, {
    path: "/personal/teams",
    component: () => import("@/views/personal/teams.vue"),
    name: "personalTeams",
    meta: {
      title: "route.team-profile",
      crumbs: "route.team-profile-crumb",
      isLogin: true,
      isNav: true
    }
  }]
}];
export default routesPersonal;